/** Legacy strings for الرخصة — Admin/AdminLicenseManagement.ar.resx + LicenseInformation. */
export const strings = {
  title: 'الرخصة', // Sitemap.AdminLicenseManagementTitle
  subtitle: 'تفاصيل عامة', // AdminLicenseManagement.SubPanelTitle

  band: 'معلومات الرخصة وإدارة الاستخدام',
  reading: {
    of: 'من',
    days: 'يوم',
    seats: 'حساب',
    left: (pct) => `المتبقي ${pct}%`,
  },
  /* The callout over today on the term line. */
  term: {
    left: (n) => `متبقي ${n} يوم`,
  },
  /* The ring beside the term, and its legend. */
  seats: {
    title: 'الحسابات',
    left: 'المتبقية',
    used: 'المستخدمة',
    /* Under the figure in the ring, so it cannot be read as "1,478 used of 1,500". */
    leftOf: 'متبقية من',
  },
  fields: {
    status: 'حالة الرخصة',
    companyName: 'اسم العميل', // LicenseDataStringClientName
    licenseType: 'نوع الرخصة', // LicenseDataStringLicenseType
    startDate: 'تاريخ البدء', // LicenseDataStringStartDate
    duration: 'المدة', // LicenseDataStringDuration
    daysLeft: 'الأيام المتبقية', // RemainingDaysText
    expirationDate: 'تاريخ الانتهاء', // ExpirationDateText
    usersNumber: 'عدد المستخدمين', // LicenseDataStringUserNumber
    consumedAccounts: 'الحسابات المستخدمة', // ConsumedAccountsText
    remainingAccounts: 'الحسابات المتبقية', // RemainingAccountsText
    featureSet: 'خصائص الرخصة', // LicenseDataStringFeatureSet
    operationType: 'نوع العملية', // LicenseDataStringOperationType
    /* Names the bar. The figure above it counts what is LEFT and the bar fills
       with what is GONE, so the bar has to say which of the two it is. */
    spent: 'المستهلك',
  },

  /* Derived on the client from `daysLeft` — the legacy prints the figure and
     leaves the reader to judge it. No new field, no new endpoint. */
  state: {
    active: 'سارية',
    expiring: 'قاربت على الانتهاء',
    expired: 'منتهية',
  },

  /* `OperationType`, as the licence FILE spells it — lower case, because that is what the
     file carries and both the history row and the upload preview read it the same way. The
     map used to hold "New"/"Renew" capitalised, which matched neither. */
  operations: {
    new: 'رخصة جديدة',
    update: 'تحديث',
    renew: 'تجديد',
    'public-key': 'مفتاح عام',
  },

  /* `VerificationMethod`, by NAME — the licence FILE carries the member name, and the
     preview reads the file rather than the server, so it needs its own map. The screen's
     other two places get `LicenseTypeString` already localised by the handler. */
  licenseTypes: {
    Open: 'مفتوحة',
    Close: 'مغلقة',
    TimeStamp: 'مدة زمنية',
    NumberOfUsers: 'عدد مستخدمين',
    NumberOfUsersAndTimeStamp: 'عدد مستخدمين ومدة زمنية',
  },

  /* The eight `LicenseFeatureSet` members, named the way the PANEL names them — a licence
     that grants صياد should say صياد, not "Phishing", because that is the word the reader
     will go looking for in the sidebar. The enum's own spelling of Gamification is
     misspelled; the key matches the enum, not the dictionary. */
  features: {
    Lms: 'البرامج التدريبية',
    Policies: 'السياسات',
    Phishing: 'صياد',
    SecurityReports: 'الحوادث السيبرانية',
    Assessments: 'القياسات',
    AwarenessContent: 'النشرات التوعوية',
    Gamififcation: 'التلعيب',
    Surveys: 'الاستبيانات',
  },

  history: {
    title: 'سجل الرخص',
    current: 'الحالية',
    licenseType: 'نوع الرخصة', // LicenseInformation.TemplateFieldResource13
    startDate: 'تاريخ البدء', // TemplateFieldResource14
    /* Not in the payload: start + duration, worked out on the client so nobody has to. */
    endDate: 'تاريخ الانتهاء',
    durationDays: 'المدة بالأيام', // AdminLicenseManagement.LicenseInfoTableHeader3
    totalAccounts: 'الحسابات', // LicenseInfoTableHeader4
  },

  /* What the server prints for a limit a licence type does not have (an open licence has
     no end and no seat cap) — the history says the same rather than a placeholder figure. */
  unlimited: 'غير محدودة',

  update: {
    trigger: 'تحديث الرخصة', // BtnLicenseUpdate
    submit: 'تحديث الرخصة', // BtnUpdate
    fileLabel: 'ملف الرخصة', // LabelLicenseFile
    renewOptions: 'خيارات التجديد', // LabelRenewOptions
    noCopy: 'لا تنسخ شيئا', // RBtnNoCopy
    copy: 'انسخ المستخدمين القدامى من الرخصة القديمة إلى الرخصة الجديدة', // RBtnCopy
    contentHeading: 'بيانات الرخصة:', // MessageLicenseFileContent
    emptyFile: 'لم يتم تحديد ملف للرخصة', // MessageEmptyFileSelection
    /* Only when the request itself failed — a refused licence is answered in the
       server's own words, which say which check did not pass. */
    failed: 'تعذر تحديث الرخصة، فضلا حاول مرة أخرى',
    wrongFileType: 'فقط الملفات من نوع ‎.json يتم قبولها', // MessageWrongFileType
    invalidLicense:
      'ملف الرخصة ربما يكون تالف أو لم يتم إصداره بواسطة مركز التميز لأمن المعلومات', // MessageInvalidLicesne
    success: 'تم تحديث بيانات الرخصة بنجاح', // MessageSuccessUpdate
    error:
      'حدث خطأ غير متوقع أثناء تحديث بيانات الرخصة، فضلا حاول مرة أخرى أو تواصل معنا', // MessageError
    noLicense: 'لم يتم العثور على رخصة سابقة في النظام', // MessageNoLicnese

    submitting: 'فضلا انتظر',
    fileHint: 'ملف الرخصة الصادر من مركز التميز لأمن المعلومات بصيغة ‎.json',
    notJson: 'تعذرت قراءة الملف، تأكد من اختيار ملف رخصة صحيح',
    noLicenseInfo: 'هذا الملف لا يحتوي على بيانات رخصة',
    /* The server refuses these two as well; saying it here saves a round trip. */
    wrongOperation: 'هذا الملف من نوع لا يطبق من هذه الشاشة، استخدم ملف تحديث أو تجديد.',

    /** The licence's own contents, shown before it is applied. */
    preview: {
      clientName: 'الجهة',
      operationType: 'نوع العملية',
      licenseType: 'نوع الرخصة',
      startDate: 'تاريخ البداية',
      usersNumber: 'عدد المستخدمين',
      duration: 'المدة',
      featureSet: 'الخصائص',
      days: (n) => `${n} يوم`,
      allFeatures: 'كل الخصائص',
      featuresIncluded: 'الخصائص المشمولة',
      /* An empty FeatureSet means the licence is not limited to any feature — the
         product reads it that way (`HasFeature` returns true for an empty set), so the
         list is drawn whole rather than left blank. */
      featuresAll: 'هذه الرخصة غير مقيدة بخصائص معينة',
      featuresSome: (n, total) => `${n} من ${total} خصائص`,
      excluded: 'غير مشمولة',
    },
  },

  unavailable: '—',
  close: 'إغلاق', // Users.btnClose
}
